<template>
  <div
    class="s-time-picker__box">
    <div
      v-if="displayHours"
      style="overflow: auto;">
      <div class="s-time-picker__box__head">
        <slot name="hours">
          {{ $t('hours') }}
        </slot>
      </div>
      <ul
        class="s-time-picker__box__list s-time-picker__box__list--hours">
        <li
          v-for="(hour, index) in timeCount(interval.h, hoursLength)"
          :key="index"
          class="s-time-picker__box__item s-time-picker__box__item--hours"
          :class="{'s-time-picker__box__item--is-selected': pickerState.selected.hour == hour, 's-time-picker__box__item--is-highlighted': getState('hour', 'highlight', hour), 's-time-picker__box__item--is-disabled': getState('hour', 'disable', hour)}"
          @click="selectTime('hour', hour, $event)">
          {{ hour }}
        </li>
      </ul>
    </div>
    <div
      v-if="displayMinutes"
      style="overflow: auto;">
      <div class="s-time-picker__box__head">
        <slot name="minutes">
          {{ $t('minutes') }}
        </slot>
      </div>
      <ul
        class="s-time-picker__box__list s-time-picker__box__list--minutes">
        <li
          v-for="(minute, index) in timeCount(interval.m)"
          :key="index"
          class="s-time-picker__box__item s-time-picker__box__item--minutes"
          :class="{'s-time-picker__box__item--is-selected': pickerState.selected.minute == minute, 's-time-picker__box__item--is-highlighted': getState('minute', 'highlight', minute), 's-time-picker__box__item--is-disabled': getState('minute', 'disable', minute)}"
          @click="selectTime('minute', minute, $event)">
          {{ minute }}
        </li>
      </ul>
    </div>
    <div
      v-if="displaySeconds"
      style="overflow: auto;">
      <div class="s-time-picker__box__head">
        <slot name="seconds">
          {{ $t('seconds') }}
        </slot>
      </div>
      <ul
        class="s-time-picker__box__list s-time-picker__box__list--seconds">
        <li
          v-for="(second, index) in timeCount(interval.s)"
          :key="index"
          class="s-time-picker__box__item s-time-picker__box__item--seconds"
          :class="{'s-time-picker__box__item--is-selected': pickerState.selected.second == second, 's-time-picker__box__item--is-highlighted': getState('second', 'highlight', second), 's-time-picker__box__item--is-disabled': getState('second', 'disable', second)}"
          @click="selectTime('second', second, $event)">
          {{ second }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { i18n } from '../utils/i18n.js'
Vue.use(i18n)

/**
 * на основе vue-timeselector
*/

export default {
  name: 'sTimePicker',
  data() {
    return {
      pickerState: {
        selected: {
          hour: null,
          minute: null,
          second: null
        },
        time: new Date(),
        isPristine: true
      },
      formater: ['HH', 'H', 'hh', 'h', 'kk', 'k', 'mm', 'm', 'ss', 's', 'a'],
      longHourCount: 24,
      shortHourCount: 12,
      minCount: 60,
      secCount: 60
    }
  },
  methods: {
    /**
    * Set a zero before a one digit number if needed by padTime props
    * @param {Number} time - number to analyze
    * @param {Boolean} force - force padding even if padTime is not set
    * @return {String|Number} - the padded number
    * @public
    */
    pad(time, force = false) {
      const result = this.padTime || force ? time.toString().padStart(2, '0') : time
      return result.trim()
    },
    /**
    * Generate a time format depending on formating props
    * @param {String} type - result of formatting
    * @return {String} - formated time
    */
    timeFormated(type) {
      if (this.placeholder && this.pickerState.isPristine) { return this.placeholder }
      // Inline formating - for display method only -(separator/displayHours... props)
      if (type === 'displayFormat' && !this.displayFormat) {
        return (this.displayHours ? this.pad(this.picker.hour) : '') +
               (this.displayMinutes && this.displayHours ? (':' + this.pad(this.picker.minute)) : (this.displayMinutes ? this.pad(this.picker.minute) : '')) +
               (this.displaySeconds ? (':' + this.pad(this.picker.second)) : '')
      }
      // RegExp formating(formats props)
      let display = this[type]
      this.formater.forEach(format => {
        if (typeof this.displayRules[format] !== 'undefined') {
          // replace time formater
          display = display.replace(new RegExp(`${format}(?!\\])`, 'g'), this.displayRules[format]())
          // replace time escaped formater
          display = display.replace(new RegExp(`\\[${format}\\]`, 'g'), format)
        }
      })
      return display
    },
    /**
    * Create time interval in list
    * @param {Number} [interval=1] - interval asked
    * @param {Number} [timeLength=60] - numbered range to work on.
    * @return {Array} - list of times to select
    * @public
    */
    timeCount(interval = 1, timeLength = 60) {
      return Array.apply(null, {length: timeLength})
        .map(Number.call, Number =>  Number)
        .filter(num => num % interval === 0)
        .map(time => this.pad(time))
    },
    /**
    * Update of the selected time on the input
    * @param {String} time - kind of time selected(hour, minute, second)
    * @param {Object} e - event listened
    * @emits selected(Hour|Minute|Second)
    * @emits input
    * @public
    */
    selectTime(type, el, e) {
      // If not disable(input as select box item)
      if (!this.disabled && !this.getState(type, 'disable', el)) {
        this.pickerState.isPristine = false
        this.picker[type] = e.target.textContent
        this.pickerState.selected[type] = el
        /**
        * Emit selectedHour selectedMinute and selectedSecond depending on what changed
        * @event selected(Hour|Minute|Second)
        * @type {Date}
        */
        this.$emit(`selected${type.charAt(0).toUpperCase() + type.slice(1)}`, this.picker[type])
        /**
        * Return formatted time if returnFormat set(absolute time ONLY)
        * @event formatedTime
        * @type {String}
        */
        if (this.returnFormat) { this.$emit('formatedTime', this.timeFormated('returnFormat')) }
        /**
        * Emit event because input has changed
        * @event input
        * @type {Date|Object}
        */
        this.$emit('input', this.time)
      } else {
        /**
        * Emit event because disabled time has been clicked
        * @event selectedDisabled
        * @type {Number}
        */
        this.$emit('selectedDisabled')
      }
    },
    /**
    * Clear time and reset modalbox
    * @public
    */
    clearTime() {
      this.pickerState.isPristine = true
      this.pickerState.selected.hour = -1
      this.pickerState.selected.minute = -1
      this.pickerState.selected.second = -1
      this.picker.hour = 0
      this.picker.minute = 0
      this.picker.second = 0
      this.$emit('input', '')
      this.$emit('cleared')
    },
    /**
    * Check if time had to chage in specific state(ie. highlight, disable...)
    * @param {String} type - type of time(hour, minute, second)
    * @param {Number} time - time to check
    * @return {Boolean} - is the time had to change
    * @public
    */
    getState(type, state, time) {
      if (this[state][type.charAt(0)]) {
        const parsedTime = parseInt(time, 10)
        const  timeAskedList = this[state][type.charAt(0)].map(h => {
          if (h instanceof Date && Object.prototype.toString.call(h) === '[object Date]') {
            h = type === 'hour' ? h.getHours() : (type === 'minute' ? h.getMinutes() : h.getSeconds())
          }
          return !isNaN(parsedTime) ? parseInt(h, 10) : h
        })
        return timeAskedList.indexOf(parsedTime) >= 0
      }
    },
  },
  computed: {
    picker() {
      return {
        hour: this.value ? (this.utc ? this.value.getUTCHours() : this.value.getHours()) : 0,
        minute: this.value ? (this.utc ? this.value.getUTCMinutes() : this.value.getMinutes()) : 0,
        second: this.value ? (this.utc ? this.value.getUTCSeconds() : this.value.getSeconds()) : 0,
      }
    },
    /**
    * Get 24|12 hours mode
    * @return {Number} - function to generate time replacement
    */
    hoursLength() {
      return this.longHourCount
    },
    /**
    * Rules that defines time replacement in regex
    * @return {Object} - function to generate time replacement
    */
    displayRules() {
      return {
        HH: () => this.pad(this.picker.hour, true),
        H: () => this.picker.hour,
        kk: () => this.pad(this.picker.hour === 0 ? this.picker.hour + 1 : this.picker.hour, true),
        k: () => this.picker.hour === 0 ? this.picker.hour + 1 : this.picker.hour,
        hh: () => {
          return this.pad(this.picker.hour > 12 ? 12 - (this.picker.hour === 0 ? this.picker.hour + 1 : this.picker.hour) : this.picker.hour === 0 ? this.picker.hour + 1 : this.picker.hour, true)
        },
        h: () => {
          return this.picker.hour > 12 ? 12 - (this.picker.hour === 0 ? this.picker.hour + 1 : this.picker.hour) : (this.picker.hour === 0 ? this.picker.hour + 1 : this.picker.hour)
        },
        mm: () => this.pad(this.picker.minute, true),
        m: () => this.picker.minute.toString(),
        ss: () => this.pad(this.picker.second, true),
        s: () => this.picker.second.toString(),
        a: () => this.picker.hour >= 12 ? 'PM' : 'AM'
      }
    },
    /**
    * Get time as date Object - UTC or not depending on props utc
    * @return {Date} - Time as a date Object
    */
    time() {
      // Change time format with AM-PM depending on choice
      // If cleared
      if (this.picker.hour === -1 && this.picker.minute === -1) { return '' }
      // Set hours in final Date format - default
      this.pickerState.time.setHours(this.picker.hour, this.picker.minute, this.picker.second)
      const date = this.value ? this.value : new Date()
      return this.utc ? new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), this.picker.hour, this.picker.minute, this.picker.second)) : new Date(this.pickerState.time)
    },
  },
  props: {
    /**
    * Data binding
    * @model
    */
    value: {
      type: [String, Date]
    },
    /**
    * Input id property
    */
    id: {
      type: String
    },
    /**
    * Input placeholder text
    */
    placeholder: {
      type: String
    },
    /**
    * Disable input
    */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
    * Display hours to the input or not
    */
    displayHours: {
      type: Boolean,
      default: true
    },
    /**
    * Display minutes to the input or not
    */
    displayMinutes: {
      type: Boolean,
      default: true
    },
    /**
    * Display seconds to the input or not
    */
    displaySeconds: {
      type: Boolean,
      default: false
    },
    /**
    * Open the picker on the first
    */
    initialView: {
      type: Boolean,
      default: false
    },
    /**
    * Pads number with a zero or not
    */
    padTime: {
      type: Boolean,
      default: false
    },
    /**
    * Time formatting string displayed
    */
    displayFormat: {
      type: String
    },
    /**
    * Time formatting string returned
    */
    returnFormat: {
      type: String
    },
    /**
    * Return UTC date format or not
    */
    utc: {
      type: Boolean,
      default: false
    },
    /**
    * Define hours, minutes and seconds interval to the picker
    */
    interval: {
      type: Object,
      default: function() {
        return {
          h: 1,
          m: 1,
          s: 5
        }
      }
    },
    /**
    * Define hours, minutes and seconds that had to be hightlighted on the picker
    */
    highlight: {
      type: Object,
      default: function () {
        return {
          h: null,
          m: null,
          s: null,
        }
      }
    },
    /**
    * Disable specific time on hours, minutes and seconds
    */
    disable: {
      type: Object,
      default: function() {
        return {
          h: null,
          m: null,
          s: null,
        }
      }
    },
  },
  watch: {
    value: function() {
      this.picker.hour = this.value ? (this.utc ? this.value.getUTCHours() : this.value.getHours()) : 0
      this.picker.minute = this.value ? (this.utc ? this.value.getUTCMinutes() : this.value.getMinutes()) : 0
      this.picker.second = this.value ? (this.utc ? this.value.getUTCSeconds() : this.value.getSeconds()) : 0
      if (!this.pickerState.isPristine) {
        this.pickerState.selected.hour = this.picker.hour,
        this.pickerState.selected.minute = this.picker.minute
        this.pickerState.selected.second = this.picker.second
        this.pickerState.time = this.value
      }
    }
  },
  created() {
    /** Get preselected time @see timeCount */
    this.value !== null && ['hour', 'minute', 'second'].forEach(type => (this.pickerState.selected[type] = this.picker[type] && this.pad(this.picker[type])))
  },
  i18n: {
    messages: {
      uk: {
        hours: 'Години',
        minutes: 'Хвилини',
        seconds: 'Секунди',
      },
      ru: {
        hours: 'Часы',
        minutes: 'Минуты',
        seconds: 'Секунды',
      },
      en: {
        hours: 'Hours',
        minutes: 'Minutes',
        seconds: 'Seconds',
      },
    }
  },
}
</script>
<style scoped lang="scss">
  .s-time-picker {
    &__box {
      display: flex;
      height: 165px;
      width: 336px;
      background: var(--white-color);
      padding-left: 6px;
      padding-bottom: 6px;
      &__item {
        cursor: pointer;
        padding: .4em 0;
        font-size: 1em;
        &--is-selected {
          background: var(--color-main-green);
          color: var(--black-color);
        }
        &--is-highlighted {
          background: var(--v-main__light_green-base);
        }
        &--is-disabled {
          cursor: auto;
          background: #f5f5f5;
          color: #a5a5a5;
          opacity: 0.5;
        }
      }
      &__list {
        list-style: none;
        padding: 0;
        margin: 0;
        flex: 1;
        text-align: center;
        overflow-x: hidden;
        overflow-y: auto;
        min-width: 100px;
      }
      &__head {
        color: #a5a5a5;
        font-size: .8em;
        padding: .8em 0 .4em;
        width: 100%;
        position: sticky;
        top: 0px;
        background: var(--white-color);
        text-align: center;
      }
    }
  }

  .s-time-picker__box__list + .s-time-picker__box__list {
    border-left: 1px solid var(--color-main-green);
  }
</style>
